import {makeAutoObservable} from 'mobx';

import type {Destructible, WithReactionDispose} from '../store';
import type {CoreOrB2bEnv} from './types';

import {appStateManager, type AppStateManager} from '../appState';
import {storage} from '../storage';
import {ReactionDisposeManager} from '../store';

const STORAGE_KEY = 'cb2b_env';

export class CoreOrB2bEnvSwitcherCoreOnly
  implements Destructible, WithReactionDispose
{
  disposer = new ReactionDisposeManager();
  isReady = false;
  private unsubscribeAppStateChange: () => void;

  constructor() {
    makeAutoObservable(this, undefined, {autoBind: true});

    this.unsubscribeAppStateChange = appStateManager.onStateChange(
      this.onAppStateChange.bind(this),
    );

    this.init();
  }

  private async init() {
    await storage.setItem(STORAGE_KEY, 'core');
    this.setIsReady();
  }

  destruct() {
    this.disposer.dispose();
    this.unsubscribeAppStateChange();
  }

  get isB2b() {
    return false;
  }

  get isCore() {
    return true;
  }

  get isOppositeEnvHasUpdates() {
    return false;
  }

  get isSwitchAvailable() {
    return false;
  }

  get oppositeEnv(): CoreOrB2bEnv {
    return 'b2b';
  }

  get shouldShowButtonTemporary() {
    return false;
  }

  toggleEnv() {
    // no-op in core-only mode
  }

  private onAppStateChange(state: AppStateManager.State) {
    if (state === 'active') {
      storage.setItem(STORAGE_KEY, 'core');
    }
  }

  private setIsReady() {
    this.isReady = true;
  }
}
